import { render } from "./FlagComponent.vue?vue&type=template&id=0be02d5c"
import script from "./FlagComponent.vue?vue&type=script&lang=js"
export * from "./FlagComponent.vue?vue&type=script&lang=js"

import "./FlagComponent.vue?vue&type=style&index=0&id=0be02d5c&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__